/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StartLlmTestCommand } from '../../models/start-llm-test-command';
import { StartLlmTestResult } from '../../models/start-llm-test-result';

export interface ApiModelsLlmTestStartPost$Params {
      body?: StartLlmTestCommand
}

export function apiModelsLlmTestStartPost(http: HttpClient, rootUrl: string, params?: ApiModelsLlmTestStartPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StartLlmTestResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsLlmTestStartPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StartLlmTestResult>;
    })
  );
}

apiModelsLlmTestStartPost.PATH = '/api/Models/llm/test/start';
